// TODO psfp : Seems liks this is only used when queueing, check and make necessary changes
$(document).ready(() => {
  var container = $('#projectWaitingList')
  if (container.length <= 0) { return; }

  subscribeToWaitingListChannel(container);
});

function subscribeToWaitingListChannel(container) {
  App.cable.subscriptions.create(
    {
      channel: 'SubscriptionWaitingListChannel',
      project_id: container.data('project-id'),
    },
    {
      initialPosition: null,

      connected() {
        this.initialPosition = $('#peopleInLine').data('position');
        this.currentPosition = this.initialPosition;
      },

      received(data) {
        setTimeout(() => {
          this.currentPosition = Math.max(0, this.currentPosition - 1);
          $('#peopleInLine').html(this.currentPosition);

          let oldDesignSubscriptionValidatedModal = $('#subscriptionValidatedModal');

          if (
            oldDesignSubscriptionValidatedModal.length &&
            !oldDesignSubscriptionValidatedModal.hasClass('show') &&
            data['collect_over'] === true
          ) {
            displayCollectOverModal('static', false);
            this.unsubscribe();
            return;
          }

          let newDesignSubscriptionValidatedContent = $('#subscriptionValidated');

          if (
            newDesignSubscriptionValidatedContent.length &&
            newDesignSubscriptionValidatedContent.hasClass('d-none') &&
            data['collect_over'] === true
          ) {
            $('#investmentModal').modal('hide');
            displayCollectOverModal('static', false);
            this.unsubscribe();
            return;
          }

          if (this.currentPosition === 0) {
            this.unsubscribe();
          }
        }, 500);
      },
    }
  )
};

function displayCollectOverModal(backdrop = true, keyboard = true) {
  const collectOverModal = new bootstrap.Modal(
    '#collectOverModal',
    {
      backdrop: backdrop,
      keyboard: keyboard
    }
  );
  collectOverModal.show();
}

// Expose top-level declarations as globals (pre-bundler concatenation behavior).
window.subscribeToWaitingListChannel = subscribeToWaitingListChannel;
